/** Harta orașului în cadrul desenului, pentru planul de situație ȘI pentru
 *  macheta lui: centrul lotului în Stereo 70 → harta de la server → cadrul
 *  desenului. O singură cerere pentru amândouă vederile; fiecare își face din
 *  ea desenul ei (`StratOras2D`, `useStratOras`).
 *
 *  `oras` se schimbă numai când se schimbă harta sau lotul, nu la fiecare
 *  revizie a soluției: stratul 3D se reconstruiește după identitatea lui. */

import { useMemo } from "react";
import { centruLot, inStereo70, orasInCadru } from "./cadru";
import type { Oras3, RaspunsOras } from "./tipuri";
import { RAZA_ORAS_M, useHartaOras } from "./useHartaOras";

export interface IntrareOras {
  /** Se cere harta? (situația pe ecran și comutatorul pornit) */
  activ: boolean;
  crs: { epsg?: number | null } | null | undefined;
  /** Originea locală a desenului (v. `canonical.origineDesen`). */
  origine: [number, number];
  /** Conturul lotului, în cadrul desenului. */
  lot: readonly number[][] | null | undefined;
  raza?: number;
}

export function useOrasInCadru({ activ, crs, origine, lot, raza = RAZA_ORAS_M }: IntrareOras):
    { oras: Oras3 | null; harta: RaspunsOras | null } {
  const cheieLot = lot?.length ? JSON.stringify(lot) : "";
  const centru = useMemo(() => centruLot(cheieLot ? JSON.parse(cheieLot) : null), [cheieLot]);
  const cx = centru?.[0] ?? null;
  const cy = centru?.[1] ?? null;
  const ox = origine[0], oy = origine[1];
  const epsg = crs?.epsg ?? null;
  const stereo = useMemo(
    () => (activ && cx != null && cy != null
      ? inStereo70({ epsg }, [ox, oy], [cx, cy]) : null),
    [activ, epsg, ox, oy, cx, cy]);
  const harta = useHartaOras(stereo, raza);

  const oras = useMemo(() => {
    if (!harta || !activ || cx == null || cy == null) return null;
    return orasInCadru(harta, { epsg }, [ox, oy], JSON.parse(cheieLot), [cx, cy]);
    // `cheieLot` ține locul lui `lot`: aceeași geometrie, alt obiect, nu reface orașul
  }, [harta, activ, epsg, ox, oy, cx, cy, cheieLot]);

  return { oras, harta: activ ? harta : null };
}
